<template>
    <div class="assignationManagement">
        <div class="assignationManagement_head">
            {{ card_name }}加油卡分配管理
        </div>
        <loadmore @loadmore="getList" :loading="loading" :isloading="isloading" :noMone="noMone">
            <div class="assignationManagement_content"> 
                <div v-for="item in data">
                    <span>{{ item.cate }}</span>
                    <span>{{ item.created_at }}</span>
                    <span v-if="item.cate=='车队现金回收'">{{ item.money }}元</span>
                    <span v-if="item.cate=='车队现金分配'">{{ item.money }}元</span>
                    <span v-if="item.cate=='车队余额回收'">{{ item.money }}升</span>
                    <span v-if="item.cate=='车队余额分配'">{{ item.money }}升</span>
                </div>
            </div>
        </loadmore>
    </div>
</template>

<script>
import common from "../common";
import loadmore from "../public/loadmore";
export default {
name: 'assignationManagement',
    data () {
        return {
            data: [],
            pageVal: "0",
            pageSize: "10",
            account_id:"",
            card_name:"",
            loading: false, //为true时不会触发加载更多，false可以触发
            isloading:true,//显示加载中
            noMone: false,//是否没有更多
            token:""
        }
    },
    mounted() {
        this.card_name=JSON.parse(this.$router.currentRoute.params.card_obj).card_name;
        this.account_id=JSON.parse(this.$router.currentRoute.params.card_obj).id;
        //判断cookie中是否存在token
        let ifcookietoken=document.cookie.indexOf("token=")!=-1;
        if(!!JSON.parse(common.getlocalStorage("userInfo"))){
            this.token=JSON.parse(common.getlocalStorage("userInfo")).token;
        } else if(ifcookietoken){
            this.token=common.getCookie("token");
        }else{
            this.$router.replace({ name: 'login'});
        }
    },
    methods: {
        //获取列表
        getList (a) {
            let token=this.token;
            let querystring = require('querystring');
            this.isloading=true;
            this.$api.post('wx/shareList',
                querystring.stringify({
                    account_id:this.account_id,
                    pageSize:this.pageSize,
                    pageNum:a,
                    token:token
                })
            ).then(data=>{
                if(a<data.data.pageTotal){
                    for(var i=0; i<this.pageSize; i++){
                        this.data.push(data.data.data[i]);
                    }
                    this.loading = false;
                }else if(a==data.data.pageTotal){
                    for(var i=0; i<data.data.data.length; i++){
                        this.data.push(data.data.data[i]);
                    }
                    this.loading = false;
                }else{
                    this.loading = true;
                    this.noMone=true;
                }
                this.isloading=false;
            }).catch(err=>{
                console.log(err);
            })
        }
    },
    created() {
        // if(!common.getlocalStorage("userInfo")){
        //     this.$router.replace({ name: 'login'});
        // }
    },
    components:{
        loadmore
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.assignationManagement{
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: -webkit-flex;
    flex-direction: column;
    background: white;
}
.assignationManagement_head{
    width: 100vw;
    height: 8vh;
    background: #0097fe;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: .6rem;
    font-weight: bold;
}
.assignationManagement_content{
    width: 100vw;
    flex: 1;
}
.assignationManagement_content>div{
    height: 5vh;
    border: 1px solid #eaeaea;
    margin: 1vh auto;
    padding: 1vh 3vw;
    display: -webkit-flex;
    align-items: center;
    font-size: .4rem;
}
.assignationManagement_content>div>span{
    display: -webkit-flex;
    justify-content: center;
}
.assignationManagement_content>div>span:nth-child(1){
    flex:1;
}
.assignationManagement_content>div>span:nth-child(2){
    flex:1.5;
}
.assignationManagement_content>div>span:nth-child(3){
    flex:1;
}
.assignationManagement_content>li{
    align-items: center;
    display: -webkit-flex;
    height: 100px;
    justify-content: center;
}
</style>
      


// WEBPACK FOOTER //
// src/components/assignationManagement.vue